import { useNavigate, useParams } from "react-router-dom";
import { Modal, Button, Dropdown } from "react-bootstrap";
import axios from "axios";
import Cookies from "js-cookie";
import LoginCheck from "../../LoginCheckAdmin/page";
import Header_ from "../compoenents/Header_";
import { AppValues, API, ApiAdmin, MAPS_API_KEY } from "../../Values";
import { useState, useMemo, useEffect, useRef } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import '@geoman-io/leaflet-geoman-free/dist/leaflet-geoman.css';
import 'leaflet-control-geocoder/dist/Control.Geocoder.css';
import 'leaflet-control-geocoder';
import L from 'leaflet';

const mapContainerStyle = {
  width: "100%",
  height: "80%",
};

const center_ = {
  lat: 30.033,
  lng: 31.233,
};

export default function GetDellerNavigation() {
  const navigate = useNavigate();
  const params = useParams();
  let [center, Setcenter] = useState(center_);
  const [DellerName, SetDelleName] = useState("");
  const [DellerPhone, SetDellePhone] = useState("");

  const [Dellerlocation, SetDellerlocation] = useState("");
  const [DellerdistanceKm, SetDellerdistanceKm] = useState("");

  const [allDrivers, setAllDrivers] = useState([]);
  const fetchIntervalRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);

  LoginCheck();
  const admininfo = Cookies.get("admininfo") ? JSON.parse(Cookies.get("admininfo")) : [];
  const AdminID = admininfo.length ? admininfo[0].ID : "";

  useEffect(() => {
    GetDeller();
  }, [params.lat, params.lng]);

  useEffect(() => {
    fetchIntervalRef.current = setInterval(() => {
      GetDeller(); // تحديث الموقع كل 5 ثواني
    }, 5000);
    return () => clearInterval(fetchIntervalRef.current);
  }, []);

  async function GetDeller() {
    try {
      const post = {
        Action: "Getdellers",
        customer_id: params.customer_id,
        service: params.service,
        lat: params.lat,
        lng: params.lng,
      };
      const response = await fetch(`${ApiAdmin}/deller_nearby.php`, {
        method: "POST",
        body: JSON.stringify(post),
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      console.log(data);
      const newLat = parseFloat(data.searchLocation.latitude);
      const newLng = parseFloat(data.searchLocation.longitude);
      Setcenter({ lat: newLat, lng: newLng });

      setAllDrivers(data.drivers);
      if (data.drivers.length > 0) {
        SetDelleName(data.drivers[0].name || "");
        SetDellePhone(data.drivers[0].phone || "");
        SetDellerlocation(data.drivers[0].locationName || "");
        SetDellerdistanceKm(data.drivers[0].distanceKm || "");



      }
    } catch (error) {
      console.error("Error fetching drivers:", error);
    }
  }






  function iconMarker(url) {
    return new L.Icon({
      iconUrl: url,
      iconSize: [32, 32],
      iconAnchor: [16, 32],
      popupAnchor: [0, -32],
    });
  }

  function MapUpdater() {
    const map = useMap();
    useEffect(() => {
      map.setView(center, map.getZoom());
    }, [center]);
    return null;
  }

  return (
    <>
      <Header_ />
      <div dir="rtl" className="row mt-0 text-center0 m-auto">
        <div className="col-12 p-0 px-2 text-center bg-white mb-2">
          <small className="text-danger bg-secondary0 px-2 text-center py-1">المندوبين القريبين من :  {params.LocationName} </small>
          {DellerName != "" && <>
            <h6 className="text-syan  py-1">اقرب مندوب :  {DellerName !== "unknown" && <small> {DellerName}</small>} </h6>
            {Dellerlocation !== "unknown" && <><small>الموقع : {Dellerlocation}</small><br /></>}
             🧭 {DellerdistanceKm} كم من الموقع
            📞 <a href={`tel:${DellerPhone}`} target="_blank">{DellerPhone}</a>
        
          </>}

        </div>
        <div className="col-master col-12 mt-0 bg-light px-1 text-center">
          <div style={{ width: '100%', height: '100%' }} id="map">
            <MapContainer
              center={center}
              zoom={15}
              style={{ width: '100%', height: '100%' }}
            >
              <TileLayer
                url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
                attribution="&copy; <a href='https://www.esri.com/'>Esri</a>"
              />
              <MapUpdater />

              {/* ماركرات المندوبين (أزرق) */}
              {allDrivers.map((driver, index) => (
                <Marker
                  key={index}
                  position={{
                    lat: parseFloat(driver.latitude),
                    lng: parseFloat(driver.longitude),
                  }}
                  icon={iconMarker("https://maps.google.com/mapfiles/ms/icons/blue-dot.png")}
                >


                  <Popup>
                    <b>{driver.name}</b><br />
                    📍 {driver.locationName}<br />
                    📞 <a href={`tel:${driver.phone}`} target="_blank">{driver.phone}</a><br />
                    🧭 {driver.distanceKm} كم من الموقع
                  </Popup>
                </Marker>
              ))}

              {/* الماركر الأساسي (أحمر) */}
              <Marker
                position={center}
                icon={iconMarker("https://maps.google.com/mapfiles/ms/icons/red-dot.png")}
              >
                <Popup>📍 موقع البحث: {center.lat}, {center.lng}</Popup>
              </Marker>
            </MapContainer>

          </div>
          <br />
        </div>
      </div>
    </>
  );
}
